import { render } from "./MainNavbar.vue?vue&type=template&id=8fb6f808&scoped=true"
import script from "./MainNavbar.vue?vue&type=script&lang=js"
export * from "./MainNavbar.vue?vue&type=script&lang=js"

import "./MainNavbar.vue?vue&type=style&index=0&id=8fb6f808&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fb6f808"]])

export default __exports__